// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BZg8","badges":"styles_badges__3zfFo"};